export default "__VITE_ASSET__D47WbY1j__"